import { computed, defineComponent } from 'vue';
import RichtextForm from './RichtextForm.vue';
export default defineComponent({
    components: { RichtextForm },
    props: {
        description: String,
        modelValue: String,
        disabled: Boolean,
        preview: Boolean
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        return {
            value
        };
    }
});
